module.exports = __webpack_public_path__ + "static/media/6530.a9e7f47e.jpg";